import {
  offWhite,
  sand,
  white,
  green,
  lightGreen,
} from '@/shared/styles/colors';
import { IsDesktopProps } from '@/shared/styles/types';
import styled, { css } from '@emotion/native';
import { Platform, ViewStyle } from 'react-native';
import { BodyText } from '@/shared/components/StyledText';

export const OnboardingContainerStyles = css({
  flex: 1,
  backgroundColor: sand,
});

export const OnboardingContentContainer = styled.View<IsDesktopProps>(
  ({ isDesktop }) => ({
    flex: 1,
    paddingTop: isDesktop ? 54 : 0,
    paddingRight: isDesktop ? 78 : 32,
    paddingLeft: isDesktop ? 56 : 32,
    paddingBottom: isDesktop ? 42 : 0,
    justifyContent: 'space-between',
    maxWidth: 1440,
    width: '100%',
    flexDirection: isDesktop ? 'row' : 'column',
    alignItems: isDesktop ? 'flex-start' : 'center',
  }),
);

export const OnboardingBottomContainer = styled.View<IsDesktopProps>(
  ({ isDesktop }) => ({
    width: isDesktop ? 581 : '100%',
  }),
);

interface OnboardingFormAreaProps extends IsDesktopProps {
  backgroundColor?: string;
}

export const OnboardingFormArea = styled.View<OnboardingFormAreaProps>(
  ({ isDesktop, backgroundColor }) => ({
    backgroundColor: backgroundColor || (isDesktop ? white : sand),
    width: isDesktop ? 581 : '100%',
    height: 'auto',
    borderRadius: 9,
    boxShadow: isDesktop ? '0px 4px 4px rgba(0, 0, 0, 0.05)' : 'none',
    marginBottom: 42,
  }),
);

interface ButtonContainerProps extends IsDesktopProps {
  width: ViewStyle['width'];
}

export const OnboardingButtonContainer = styled.View<ButtonContainerProps>(
  ({ isDesktop, width }) => ({
    flexDirection: 'row',
    position: isDesktop ? 'relative' : 'sticky',
    bottom: 0,
    width,
    maxWidth: isDesktop ? 214 : 'auto',
    justifyContent: isDesktop ? 'flex-end' : 'center',
    backgroundColor: isDesktop ? sand : offWhite,
    paddingHorizontal: isDesktop ? 0 : 32,
    paddingVertical: isDesktop ? 0 : 23,
    marginLeft: Platform.OS === 'ios' ? 0 : isDesktop ? 'auto' : -32,
    marginRight: isDesktop ? 0 : -32,
  }),
);

export const BoldHighlight = styled(BodyText)({
  fontSize: 16,
  fontWeight: 'bold',
  color: green,
});

export const NoteText = styled(BodyText)({
  fontSize: 14,
  lineHeight: 18,
  color: lightGreen,
  textAlign: 'center',
});
